export default __webpack_public_path__ + "static/media/up.bbfaaa1a.svg";